import {
  EnvironmentProviders,
  inject,
  isDevMode,
  makeEnvironmentProviders,
  provideAppInitializer
} from "@angular/core";
import { provideTransloco } from "@jsverse/transloco";
import { provideTranslocoLocale } from "@jsverse/transloco-locale";

import { APP_LANGUAGES, DEFAULT_LANGUAGE } from "./i18n.tokens";
import { LanguageService } from "./language.service";
import { TranslocoHttpLoader } from "./transloco-http.loader";

const langToLocaleMapping = APP_LANGUAGES.reduce<Record<string, string>>((acc, lang) => {
  acc[lang.code] = lang.locale;
  return acc;
}, {});

// Currency is not derived from UI language; defaultCurrency is only a last-resort fallback.
export function provideI18n(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTransloco({
      config: {
        availableLangs: APP_LANGUAGES.map((l) => l.code),
        defaultLang: DEFAULT_LANGUAGE,
        fallbackLang: DEFAULT_LANGUAGE,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          logMissingKey: isDevMode(),
          useFallbackTranslation: true
        }
      },
      loader: TranslocoHttpLoader
    }),
    provideTranslocoLocale({
      langToLocaleMapping,
      defaultCurrency: "INR"
    }),
    provideAppInitializer(() => inject(LanguageService).init())
  ]);
}
